<div [ngStyle]="{'background-image': 'url(' + backgroundImage + ')'}" class="zone-selection-container">
  <div class="zones">
    <div [ngClass]="{'justify-content-center-when-search-activated': showSearchInput}" class="list-title">
      <div *ngIf="!showSearchInput" class="zones-header-child first">
        <button (click)="back()" *ngIf="!singleResort && resortSelected" mat-button>
          <mat-icon>arrow_back</mat-icon>
        </button>
      </div>
      <div
        *ngIf="!showSearchInput" class="zones-header-child title">
        <div *ngIf="resortSelected">{{resortSelected.name}}</div>
        <span *ngIf="!resortSelected">{{('zone.title' | translate)}}</span>
      </div>
      <div class="search-wrapper zones-header-child">
        <button (click)="toggleSearchInput()" *ngIf="!showSearchInput" mat-button>
          <mat-icon>search</mat-icon>
        </button>
        <div *ngIf="showSearchInput" class="active-search">
          <mat-form-field  appearance="outline" class="search-input" style="flex-direction: inherit;">
            <input [(ngModel)]="search" matInput placeholder="Recherche">
            <button (click)="toggleSearchInput()" class="close-button" mat-button>
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>

      </div>
    </div>
    <mat-spinner *ngIf="!(resorts$ | async)" class="spinner"></mat-spinner>
    <mwo-item-selector (itemSelected)=" !resortSelected ? onResortSelected($event) : onRemoteSelected($event)"
                       [itemList]="!resortSelected ? (resorts$ | async) : (remotes$ | async)"
                       [itemsType]="!resortSelected ? 'RESORT' : 'REMOTE'"
                       [search]="search"></mwo-item-selector>
  </div>
</div>

